import type { ProductFeeFormInput } from '../schemas/productFee.schema';
import type { ProductFeeRecord } from '../services/productFees';

/** Seeds the edit form from the stored four-place amounts, so re-saving never rounds them. */
export const buildProductFeeFormDefaults = (row: ProductFeeRecord): ProductFeeFormInput => ({
    fee_id:               row.fee_id,
    value_type_id:        row.value_type?.id ?? '',
    scheduling_method_id: row.scheduling_method?.id ?? '',
    paid_by_id:           row.paid_by?.id ?? '',
    paid_to_id:           row.paid_to?.id ?? '',
    vat_category_id:      row.vat_category?.id ?? '',
    applies_to_ids:       (row.applies_to ?? []).map((r) => r.id),
    application_scope:    row.application_scope,
    is_absorbed:          row.is_absorbed,
    cap_value_gross:      row.cap_value_gross_money?.amount_raw ?? null,
    default_cost_net:     row.default_cost_net_money?.amount_raw ?? null,
    default_cost_gross:   row.default_cost_gross_money?.amount_raw ?? null,
    default_percentage:   row.default_percentage ?? null,
    display_order:        row.display_order,
    bands: (row.bands ?? []).map((b) => ({
        band_index: b.band_index,
        cost_net:   b.cost_net_money?.amount_raw ?? null,
        cost_gross: b.cost_gross_money?.amount_raw ?? null,
        percentage: b.percentage ?? null,
    })),
});
